/* import { useEffect, useState } from "react";
import { ReactComponent as ArrowDownIcon } from "./icons/arrow-down.svg";
import { ReactComponent as ArrowUpIcon } from "./icons/arrow-up.svg";
import { ReactComponent as BoxIconLine } from "./icons/box.svg";
import { ReactComponent as GroupIcon } from "./icons/group.svg";
import { ReactComponent as ChartIcon } from "./icons/chart.svg";
import { ReactComponent as VideoIcon } from "./icons/video.svg";
import { ReactComponent as GlobeIcon } from "./icons/globe.svg";
import { ReactComponent as TrendUpIcon } from "./icons/trend-up.svg";
import Badge from "./ui/badge/Badge";
import {
  ChartBarIcon,
  ChatBubbleBottomCenterTextIcon,
  ClockIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";

export default function EcommerceMetrics({ onCardClick }) {
  const [metrics, setMetrics] = useState({}); 

  useEffect(() => {
  fetchManufacturerInfoCharts();
}, []);


const fetchManufacturerInfoCharts = async (manufacturerId="678e1bdf3ce3c1c267977a1e", period = "year") => {
    try {
      //const userData = JSON.parse(sessionStorage.getItem("userData"));
      //const token = userData?.token;

      const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
      const apiUrl = `${fetchUrl}manufacturer/get-manufacture-infocharts?manufacturerId=${manufacturerId}&period=${period}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          //"x-token": token,
        },
      });

      const data = await response.json();
      console.log("Fetched metrics:", data);
      if (response.ok && data) {
        setMetrics(data);   // ✅ directly update state here
      } else {
        console.error("Failed to fetch metrics:", data.message);
      }
    } catch (error) {
      console.error("Error in fetchManufacturerInfoCharts:", error);
    }
  };


  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-6">
      <MetricCard
        icon={<GroupIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label1="Total Leads"
        onClick={() => onCardClick("leads")}
        data={{
          Month: { value1: "1,245", change: "+8.5%", isPositive: true },
          Quarter: { value1: "3,652", change: "+12.3%", isPositive: true },
          Year: { value1: "14,245", change: "+18.9%", isPositive: true },
        }}
      />

      <MetricCard
        icon={<GroupIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label1="Total RFQs"
        onClick={() => onCardClick("rfq")}
        data={{
          Month: { value1: "320", change: "+15.3%", isPositive: true },
          Quarter: { value1: "950", change: "+20.1%", isPositive: true },
          Year: { value1: "3,870", change: "+25.4%", isPositive: true },
        }}
      />

      <MetricCard
        icon={<ChartBarIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label1="Conversion Rate"
        onClick={() => onCardClick("rfq")}
        data={{
          Month: { value1: "12.4%", change: "+1.2%", isPositive: true },
          Quarter: { value1: "13.0%", change: "+1.8%", isPositive: true },
          Year: { value1: "14.2%", change: "+2.5%", isPositive: true },
        }}
      />

      <MetricCard
        icon={
          <ChatBubbleBottomCenterTextIcon className="text-gray-800 size-6 dark:text-white/90" />
        }
        label1="RFQ Response Rate"
        onClick={() => onCardClick("salesrep")}
        data={{
          Month: { value1: "87%", change: "+4.5%", isPositive: true },
          Quarter: { value1: "85%", change: "+3.2%", isPositive: true },
          Year: { value1: "88%", change: "+5.1%", isPositive: true },
        }}
      />

      <MetricCard
        icon={<ClockIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label1="RFQ Avg Response Time"
        onClick={() => onCardClick("salesrep")}
        data={{
          Month: { value1: "2h 15m", change: "-10m", isPositive: true },
          Quarter: { value1: "2h 05m", change: "-20m", isPositive: true },
          Year: { value1: "1h 50m", change: "-35m", isPositive: true },
        }}
      />

      <MetricCard
        icon={<BoxIconLine className="text-gray-800 size-6 dark:text-white/90" />}
        label="Order Fulfillment Rate"
        data={{
          Month: { value: "89%", change: "-0.9%", isPositive: false },
          Quarter: { value: "90%", change: "+0.5%", isPositive: true },
          Year: { value: "88%", change: "-1.5%", isPositive: false },
        }}
      />

      <MetricCard
        icon={<VideoIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label1="Video Engagement"
        onClick={() => onCardClick("product")}
        data={{
          Month: { value1: "4,523 views", change: "+5.4%", isPositive: true },
          Quarter: { value1: "12,540 views", change: "+7.8%", isPositive: true },
          Year: { value1: "48,320 views", change: "+9.5%", isPositive: true },
        }}
      />

         <MetricCard
        icon={<ChartIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label1="Product Page Perf. vs Avg Competitor"
        onClick={() => onCardClick("product")}
        data={{
          Month: { value1: "+12%", change: "+12%", isPositive: true },
          Quarter: { value1: "+14%", change: "+14%", isPositive: true },
          Year: { value1: "+15%", change: "+15%", isPositive: true },
        }}
      />


      <MetricCard
        icon={<PhoneIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label1="Calls Initiated"
        label2="Calls Attended"
        onClick={() => onCardClick("brand")}
        data={{
          Month: { value1: "Up", change: "+", isPositive: true ,value2: "15.2%", change2: "+2.1%", isPositive2: true},
          Quarter: { value1: "Up", change: "+", isPositive: true,value2: "16.0%", change2: "+2.5%", isPositive2: true  },
          Year: { value1: "Up", change: "+", isPositive: true,value2: "17.8%", change2: "+3.1%", isPositive2: true },
        }}
      />

      <MetricCard
        icon={<PhoneIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label="Calls Attended"
        onClick={() => onCardClick("market")}
        data={{
          Month: { value: "15.2%", change: "+2.1%", isPositive: true },
          Quarter: { value: "16.0%", change: "+2.5%", isPositive: true },
          Year: { value: "17.8%", change: "+3.1%", isPositive: true },
        }}
      />

   
      <MetricCard
        icon={<TrendUpIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label="Brand Perception"
        onClick={() => onCardClick("brand")}
        data={{
          Month: { value: "Up", change: "+", isPositive: true },
          Quarter: { value: "Up", change: "+", isPositive: true },
          Year: { value: "Up", change: "+", isPositive: true },
        }}
      />

      <MetricCard
        icon={<GlobeIcon className="text-gray-800 size-6 dark:text-white/90" />}
        label="Market Share On Brickbucket"
        onClick={() => onCardClick("market")}
        data={{
          Month: { value: "15.2%", change: "+2.1%", isPositive: true },
          Quarter: { value: "16.0%", change: "+2.5%", isPositive: true },
          Year: { value: "17.8%", change: "+3.1%", isPositive: true },
        }}
      />
    </div>
  );
}



function MetricCard({ icon, label1,label2, data, onClick }) {
  const [period, setPeriod] = useState("Month");
  const { value1,value2, change, isPositive } = data[period];

  return (
    <div
      onClick={onClick}
      className="cursor-pointer rounded-2xl border border-gray-200 bg-white p-4 sm:p-5 md:p-6 dark:border-gray-800 dark:bg-white/[0.03]"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center justify-center w-12 h-12 flex-shrink-0 bg-gray-100 rounded-xl dark:bg-gray-800">
          {icon}
        </div>

        <Badge color={isPositive ? "success" : "error"} className="flex-shrink-0">
          {isPositive ? <ArrowUpIcon /> : <ArrowDownIcon />}
          {change}
        </Badge>

        <select
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          className="text-xs sm:text-sm border border-gray-300 rounded-md px-2 py-1 
                     dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 
                     focus:outline-none flex-shrink-0 max-w-full"
        >
          <option>Month</option>
          <option>Quarter</option>
          <option>Year</option>
        </select>
      </div>

      <div className="flex flex-wrap items-end justify-between mt-5 gap-2">
        <div className="min-w-0">
          <span className="text-sm text-gray-500 dark:text-gray-400 truncate block">
            {label1}
          </span>
          <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
            {value1}
          </h4>
        </div>
        <div className="min-w-0">
          <span className="text-sm text-gray-500 dark:text-gray-400 truncate block">
            {label2}
          </span>
          <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
            {value2}
          </h4>
        </div>

      </div>
    </div>
  );
}


 */



import { useEffect, useState } from "react";
import {
  Users,
  FileText,
  Video,
  Phone
} from "lucide-react";


export default function EcommerceMetrics({ onCardClick }) {
  const [metrics, setMetrics] = useState(null);
  const [period, setPeriod] = useState("month"); // default period

  useEffect(() => {
    fetchManufacturerInfoCharts(period);
  }, [period]);

  const fetchManufacturerInfoCharts = async (
    period,
    manufacturerId = sessionStorage.getItem('userId')
  ) => {
    try {
      const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
      const apiUrl = `${fetchUrl}manufacturer/get-manufacture-infocharts?manufacturerId=${manufacturerId}&period=${period}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      console.log("Fetched metrics:", data);
      if (response.ok && data) {
        setMetrics(data);
      } else {
        console.error("Failed to fetch metrics:", data.message);
      }
    } catch (error) {
      console.error("Error in fetchManufacturerInfoCharts:", error);
    }
  };

  if (!metrics) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-4">
  {/* SECTION HEADER */}
  <h2 className="text-lg md:text-2xl font-bold mt-4">
    Leads & RFQ Performance
  </h2>
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 lg:grid-cols-3 md:gap-6">
      {/* Leads */}
      <MetricCard
       icon={<Users className="h-4 w-4 text-gray-600" />}
       label1="Total Leads"
        data={metrics.leads}
        onClick={() => onCardClick("leads")}
        period={period}
        onPeriodChange={setPeriod}
      />

      {/* RFQ, RFQ Response Rate, RFQ Avg Response Time in one card */}
      <MultiMetricCard
  icon={<FileText className="h-4 w-4 text-gray-600" />}
        title="RFQ Metrics"
        values={[
          {
            label: "Total RFQs",
            value: metrics.rfq.total.value,
            change: metrics.rfq.total.change,
            isPositive: metrics.rfq.total.isPositive,
          },
          {
            label: "Response Rate",
            value: metrics.rfq.responseRate.value,
            change: metrics.rfq.responseRate.change,
            isPositive: metrics.rfq.responseRate.isPositive,
          },
          {
            label: "Avg Response Time",
            value: metrics.rfq.avgResponseTime.value,
            change: metrics.rfq.avgResponseTime.change,
            isPositive: metrics.rfq.avgResponseTime.isPositive,
          },
        ]}
        onClick={() => onCardClick("rfq")}
        period={period}
        onPeriodChange={setPeriod}
      />

      {/* Video + Product Page Views in one card */}
      <MultiMetricCard
  icon={<Video className="h-4 w-4 text-gray-600" />}
        title="Product Engagement"
        values={[
          {
            label: "Video Engagement",
            value: metrics.productEngagements.videoViews.value,
            change: metrics.productEngagements.videoViews.change,
            isPositive: metrics.productEngagements.videoViews.isPositive,
          },
          {
            label: "Page Views",
            value: metrics.productEngagements.pageViews.value,
            change: metrics.productEngagements.pageViews.change,
            isPositive: metrics.productEngagements.pageViews.isPositive,
          },
        ]}
        onClick={() => onCardClick("product")}
        period={period}
        onPeriodChange={setPeriod}
      />

      {/* Calls (initiated + answered) */}
      <MultiMetricCard
  icon={<Phone className="h-4 w-4 text-gray-600" />}
        title="Calls"
        values={[
          {
            label: "Initiated",
            value: metrics.calls.initiated.value,
            change: metrics.calls.initiated.change,
            isPositive: metrics.calls.initiated.isPositive,
          },
          {
            label: "Answered",
            value: metrics.calls.answered.value,
            change: metrics.calls.answered.change,
            isPositive: metrics.calls.answered.isPositive,
          },
        ]}
        onClick={() => onCardClick("calls")}
        period={period}
        onPeriodChange={setPeriod}
      />
    </div>
    </div>
  );
}

/* --- Metric Card (Single Value) --- */
function MetricCard({ icon, label1, data, onClick, period, onPeriodChange }) {
  return (
    <div
      onClick={onClick}
      className="bg-white border rounded-xl p-4 shadow-sm cursor-pointer"
    >
      {/* HEADER */}
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-medium">{label1}</p>

        <div className="flex items-center gap-2">
          {icon}
          <select
            value={period}
            onChange={(e) => onPeriodChange(e.target.value.toLowerCase())}
            onClick={(e) => e.stopPropagation()}
            className="border rounded px-2 py-1 text-xs bg-gray-100"
          >
            <option value="month">Month</option>
            <option value="quarter">Quarter</option>
            <option value="year">Year</option>
          </select>
        </div>
      </div>

      {/* VALUE */}
      <p className="text-lg md:text-3xl font-bold">
        {data.value}
      </p>

      {/* CHANGE BADGE */}
      <span
        className={`inline-block mt-2 text-xs px-2 py-1 rounded ${
          data.isPositive
            ? "bg-green-100 text-green-700"
            : "bg-red-100 text-red-700"
        }`}
      >
        {data.isPositive ? "↑" : "↓"} {data.change}
      </span>
    </div>
  );
}


/* --- Multi Metric Card (Multiple Values in One Card) --- */
function MultiMetricCard({
  icon,
  title,
  values,
  onClick,
  period,
  onPeriodChange,
}) {
  return (
    <div
      onClick={onClick}
      className="bg-white border rounded-xl p-4 shadow-sm cursor-pointer"
    >
      {/* HEADER */}
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-medium">{title}</p>

        <div className="flex items-center gap-2">
          {icon}
          <select
            value={period}
            onChange={(e) => onPeriodChange(e.target.value.toLowerCase())}
            onClick={(e) => e.stopPropagation()}
            className="border rounded px-2 py-1 text-xs bg-gray-100"
          >
            <option value="month">Month</option>
            <option value="quarter">Quarter</option>
            <option value="year">Year</option>
          </select>
        </div>
      </div>

      {/* METRICS LIST */}
      <div className="space-y-2 text-sm">
        {values.map((item, idx) => (
          <div key={idx} className="flex justify-between">
            <span className="text-gray-500">{item.label}</span>

            <div className="flex items-center gap-2">
              <span className="font-bold">{item.value}</span>
              <span
                className={`text-xs px-2 py-1 rounded ${
                  item.isPositive
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {item.isPositive ? "↑" : "↓"} {item.change}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

